"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.IMAGE_EDIT = exports.IMAGE_ICON = exports.IMAGE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var isImportant = function isImportant(a) {
  return "".concat(a, " !important");
},
    CIRCULAR_IMAGE = {
  border: "1px solid rgba(0, 0, 0, 0)",
  borderRadius: "50%",
  backgroundSize: "cover",
  overflow: "hidden"
},
    IMAGE = function IMAGE(a) {
  var b = a.clickable,
      c = a.circular;
  return (0, _cxs["default"])(_objectSpread({
    alignItems: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    display: "inline-flex",
    position: "relative",
    borderWidth: isImportant("0px"),
    borderRadius: "inherit",
    pointer: b ? "cursor" : "default"
  }, c ? CIRCULAR_IMAGE : {}));
};

exports.IMAGE = IMAGE;

var IMAGE_ICON = function IMAGE_ICON(a) {
  var b = a.background,
      c = a.width,
      d = a.height,
      e = a.defaultIconSize,
      f = a.color,
      g = a.hasSubtitle;
  return (0, _cxs["default"])(_objectSpread({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    background: _vars.FLATTENED_COLOURS[b],
    height: d,
    width: c,
    paddingTop: g ? "10px" : void 0
  }, f ? {
    " > p": {
      color: _vars.FLATTENED_COLOURS[f]
    }
  } : {}, {}, e ? {} : {
    " > .icon-container": {
      height: "60%",
      width: "60%",
      " > .icon": {
        height: "100% !important",
        width: "100% !important"
      },
      " > .icon > svg": {
        height: "100% !important",
        width: "100% !important"
      }
    }
  }));
};

exports.IMAGE_ICON = IMAGE_ICON;
var IMAGE_EDIT = (0, _cxs["default"])({
  alignItems: "center",
  background: _vars.COLOURS.mono.black,
  bottom: "0",
  color: _vars.COLOURS.mono.white,
  display: "flex",
  fontSize: "10px",
  opacity: "0.75",
  position: "absolute",
  right: "0",
  height: "20px",
  width: "75px",
  justifyContent: "center",
  " > .icon-container": {
    marginRight: "10px"
  },
  " > p": {
    paddingTop: "2px",
    fontSize: "12px",
    margin: 0,
    lineHeight: "12px"
  }
});
exports.IMAGE_EDIT = IMAGE_EDIT;